// extracted by mini-css-extract-plugin
export default {"iframe":"SZGYKD758+YF-M3+hqu7rA=="};